import {forEach} from "lodash"

/**
 * Takes a url path and a object keys and it finds and replaces the found keys in the path name.
 *
 * ```
 * injectRoute("/abc/:def/:hij", {def: "xyz", hij: "wer})
 * ```
 *
 * would return
 *
 * ```
 * "/abc/xyz/wer"
 * ```
 *
 * @param path
 * @param keys
 * @returns {string}
 */
export const injectRoute = (path, keys) => {
  let result = path
  forEach(keys, (value, key) => {
    const re = new RegExp(`:${key}(/|$)`)
    result = result.replace(re, (match, group1) => {
      return value + group1
    })
  })
  return result
}

export default injectRoute
